import * as types from "../constants/actionTypes";

export const portalInitialState = {
    searching: false,
    searchSuccess: false,
    searchFailure: false,
    searchError: null,
    searchResults: null, // will be an array after searching
    epicFluRecords: [],
    epicFluRecordsSuccess: false,
    epicFluRecordsPending: false,
    hasCurrentFluVaccine: false,
    peopleSoftFluRecordsSuccess: false,
    peopleSoftFluRecordsPending: false,
    peopleSoftFluRecords: [],
    fluStatusSummary: null,
    fluStatusPending: false,
    fluStatusFailure: false,
    hideFluVaccineTile: null,
    roomStatuses: [],
    consumerJWT: null,
    providerJWT: null,
    consumerJWTPending: false,
    providerJWTPending: false,
    consumerJWTFailure: false,
    providerJWTFailure: false,
    revokeHpFhirGrantSuccess: false,
    revokeHpFhirGrantFailure: false,
    videoVisitShareLinkTerms: {
        isWaiting: false, terms: null, isSuccess: false, isFailure: false
    },
    shareLinkTermsStatus: {
        isWaiting: false, hasAccepted: false
    },
    acceptVideoVisitShareLinkTerms: {
        isWaiting: false, isSuccess: false, isFailure: false
    },
    showOnBoardingPhaseOneToolTipWeb: false,
    showLinkMedicalRecordPhaseOneToolTip: false,
    showOnBoardingPhaseTwoToolTipWeb: false
};

export default function portalReducer(state = portalInitialState, action) {
    switch (action.type) {
        case types.SITE_SEARCH_START:
            //debugger;
            return { ...state, searching: true, searchSuccess: false, searchFailure: false, searchError: null, searchResults: null, searchLastTerm: action.searchPhrase };

        case types.SITE_SEARCH_SUCCESS:
            return { ...state, searching: false, searchSuccess: true, searchFailure: false, searchError: null, searchResults: action.searchResults };

        case types.SITE_SEARCH_FAILURE:
            return { ...state, searching: false, searchSuccess: false, searchFailure: true, searchError: action.searchError, searchResults: null };

        case types.PATIENT_PHOTO_START: return { ...state, patientPhoto: { ...state.patientPhoto, inProcess: true } };
        case types.PATIENT_PHOTO_SUCCESS: return { ...state, patientPhoto: { ...state.patientPhoto, inProcess: false, response: action.response, error: null } };
        case types.PATIENT_PHOTO_FAILURE: return { ...state, patientPhoto: { ...state.patientPhoto, inProcess: false, response: null, error: action.error } };

        case types.GET_COMPLETE_FLU_STATUS_PENDING:
            return { ...state, fluStatusPending: true, fluStatusFailure: false };

        case types.GET_COMPLETE_FLU_STATUS_SUCCESS:
            return { ...state, fluStatusSummary: action.results, fluStatusPending: false, fluStatusFailure: false };

        case types.GET_COMPLETE_FLU_STATUS_FAILURE:
            return { ...state, fluStatusSummary: action.results, fluStatusPending: false, fluStatusFailure: true };

        case types.DISABLE_FLU:
            return { ...state, epicFluRecordsPending: false, peopleSoftFluRecordsPending: false, fluStatusPending: false, fluStatusFailure: false, epicFluRecords: [], peopleSoftFluRecords: [], fluStatusSummary: {} };

        case types.GET_ROOM_STATUSES_SUCCESS:
            return { ...state, roomStatuses: action.statuses.statuses };

        case types.GET_CONSUMER_JWT_PENDING:
            return { ...state, consumerJWTPending: true, consumerJWTFailure: false };

        case types.GET_CONSUMER_JWT_SUCCESS:
            return { ...state, consumerJWT: action.consumerToken, consumerJWTPending: false, consumerJWTFailure: false };

        case types.GET_CONSUMER_JWT_FAILURE:
            return { ...state, consumerJWTPending: false, consumerJWTFailure: true };

        case types.GET_PROVIDER_JWT_PENDING:
            return { ...state, providerJWTPending: true, consumerJWTFailure: false };

        case types.GET_PROVIDER_JWT_SUCCESS:
            return { ...state, providerJWT: action.providerToken, providerJWTPending: false, providerJWTFailure: false };

        case types.GET_PROVIDER_JWT_FAILURE:
            return { ...state, providerJWTPending: false, providerJWTFailure: true };

        case types.GET_TERMS_FOR_VIDEO_VISIT_SHARELINK_PENDING:
            return {
                ...state,
                videoVisitShareLinkTerms: {
                    isWaiting: true,
                    terms: null, isSuccess: false, isFailure: false
                }
            };

        case types.GET_TERMS_FOR_VIDEO_VISIT_SHARELINK_SUCCESS:
            return {
                ...state,
                videoVisitShareLinkTerms: {
                    isWaiting: false, terms: action.terms, isSuccess: true, isFailure: false
                }
            };

        case types.GET_TERMS_FOR_VIDEO_VISIT_SHARELINK_FAILURE:
            return {
                ...state,
                videoVisitShareLinkTerms: {
                    isWaiting: false, terms: null, isSuccess: false, isFailure: true
                }
            };

        case types.GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK_PENDING:
            return {
                ...state,
                shareLinkTermsStatus: {
                    isWaiting: true, hasAccepted: false
                }
            };

        case types.GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK_SUCCESS:
            return {
                ...state,
                shareLinkTermsStatus: {
                    isWaiting: false, hasAccepted: action.response ? action.response.hasAccepted : false
                }
            };

        case types.GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK_FAILURE:
            return {
                ...state,
                shareLinkTermsStatus: {
                    isWaiting: false, hasAccepted: false
                }
            };

        case types.ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK_PENDING:
            return {
                ...state,
                acceptVideoVisitShareLinkTerms: {
                    isWaiting: true, isSuccess: false, isFailure: false
                }
            };

        case types.ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK_SUCCESS:
            return {
                ...state,
                acceptVideoVisitShareLinkTerms: {
                    isWaiting: false, isSuccess: true, isFailure: false
                }
            };

        case types.ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK_FAILURE:
            return {
                ...state,
                acceptVideoVisitShareLinkTerms: {
                    isWaiting: false, isSuccess: false, isFailure: true
                }
            };

        case types.HIDE_FLU_VACCINE_TILE:
            return {
                ...state,
                hideFluVaccineTile: action.hideFluVaccineTile
            };

        case types.SHOW_ONBOARDING_PHASEONE_TOOLTIP:
            return {
                ...state,
                showOnBoardingPhaseOneToolTipWeb: action.showOnBoardingPhaseOneToolTipWeb
            };

        case types.SHOW_ONBOARDING_PHASETWO_TOOLTIP:
            return {
                ...state,
                showOnBoardingPhaseTwoToolTipWeb: action.showOnBoardingPhaseTwoToolTipWeb
            };

        case types.SHOW_LINK_MEDICALRECORD_PHASEONE_TOOLTIP:
            return {
                ...state,
                showLinkMedicalRecordPhaseOneToolTip: action.showLinkMedicalRecordPhaseOneToolTip
            };
        
        case types.REVOKE_HP_FHIR_GRANT_PENDING:
            return {
                ...state,
                revokeHpFhirGrantSuccess: false, revokeHpFhirGrantFailure: false, revokeHpFhirGrantPending: true,
            };

        case types.REVOKE_HP_FHIR_GRANT_SUCCESS:
            return {
                ...state,
                revokeHpFhirGrantSuccess: true, revokeHpFhirGrantFailure: false, revokeHpFhirGrantPending: false,
            };

        case types.REVOKE_HP_FHIR_GRANT_FAILURE:
            return {
                ...state,
                revokeHpFhirGrantSuccess: false, revokeHpFhirGrantFailure: true, revokeHpFhirGrantPending: false,
            };



        case types.LOGOUT:
            return portalInitialState;
        default:
            return { ...state };
    }
}
